// removed by extract-text-webpack-plugin
module.exports = {"inventorySearch":"_29R5c","universal":"_2MFUE","placeholder":"_1Rvib","searchInput":"_2GbAx","searchButton":"_2Zozx","mobileExpandButton":"_2oxq7","expanded":"_3h8Od","searchSuggestions":"_2UdHh"};


//////////////////
// WEBPACK FOOTER
// ./banquet/components/InventorySearch/index.sass
// module id = 1483
// module chunks = 1